import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ConnectedAccountsResource extends AuthenticatedResource {
  static urlRoot = '/connected_accounts'

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
